/**
 * Вспомогательный модуль, для использования в тестах или примерах.
 *
 * @internal
 */

import { theme as themeExternal } from './external';
import { theme as themeInternal } from './internal';
export const presets = {
  external: themeExternal,
  internal: themeInternal
};
const keys = Object.keys;
export const presetsKeys = keys(presets);